import Env from 'src/environmentVariables/EnvironmentVariables';

export const WEBSOCKET_URL = Env.dlobWsServerToUse;
export const WS_TIMEOUT_MS = 5000;
export const FALLBACK_COOLDOWN_MS = 60000;
export const TAB_INACTIVE_DISCONNECT_DELAY_MS = 5000;
export const RECOVERY_CHECK_INTERVAL_MS = 5000;
